import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
const ArrowDownIcon = ({
  color = '$neutrals-700',
  width = '24',
  height = '24',
  className
}: IconProps) => <SvgIcon className={className} width={`${width}px`} height={`${height}px`} viewBox={`0 0 ${width} ${height}`} data-sentry-element="SvgIcon" data-sentry-component="ArrowDownIcon" data-sentry-source-file="ArrowDownIcon.tsx">
		<path d="M18.295 9.70498L16.885 8.29498L12.295 12.875L7.70504 8.29498L6.29504 9.70498L12.295 15.705L18.295 9.70498Z" fill={color} data-sentry-element="path" data-sentry-source-file="ArrowDownIcon.tsx" />
	</SvgIcon>;
export default ArrowDownIcon;